export default [
  { id: "#path5419", d: "M195.4,218.5l55.9-62l-22.4-25.9L195.4,218.5z" },
  { id: "#path4232", d: "M226.6,537.2l-34.5-2.6l-8.7-17.2L226.6,537.2z" },
  { id: "#path4236", d: "M185.1,313.9l46.1,34.5v-60.8L185.1,313.9z" },
  { id: "#path4240", d: "M449.8,563.4l-55.8-76.3l90.5,6.4L449.8,563.4z" },
  { id: "#path4244", d: "M328.5,318.9l-29.1-23.8l1.1,50.5L328.5,318.9z" },
  { id: "#path4248", d: "M383.4,106.2l2.9,45.4l-15.2,0.8L383.4,106.2z" },
  { id: "#path4252", d: "M373.6,341l98.4,13l-114.2-28.5L373.6,341z" },
  { id: "#path4628", d: "M417.9,396.8L472,354l-100.5,33.2L417.9,396.8z" },
  { id: "#path4632", d: "M183.4,450.2l47.6-102l69.5-2.6L183.4,450.2z" },
  { id: "#path4634", d: "M300.7,345.6l-1.1-50.5l-68.2,53.1L300.7,345.6z" },
  { id: "#path4636", d: "M398.2,114.5L419,60.9l21,99.4L398.2,114.5z" },
  { id: "#path4644", d: "M256.7,115.6l-27.8,15.2h51.6L256.7,115.6z" },
  { id: "#path4646", d: "M566.1,174.1L600,293l-65.5-53L566.1,174.1z" },
  { id: "#path4648", d: "M228.8,130.7l-78.2,23.5L100,82.5L228.8,130.7z" },
  { id: "#path4656", d: "M100.1,82.5l128.7,48.2L109.7,60.9L100.1,82.5z" },
  { id: "#path4660", d: "M231.2,287.4l-35.7-18.3l71.5-43.9L231.2,287.4z" },
  { id: "#path4662", d: "M297.3,495.7l-40.7,32.1l-3.9-15.9L297.3,495.7z" },
  { id: "#path4672", d: "M280.5,130.7l103-24.5L267,225.3L280.5,130.7z" },
  { id: "#path4674", d: "M313.1,516.3l37.8-64.5l-53.6,43.9L313.1,516.3z" },
  { id: "#path4676", d: "M199.8,487.1l-16.3,30.3l-11.6-18.1L199.8,487.1z" },
  { id: "#path4678", d: "M171.8,499.3l11.6,18.1l-25.6-19.5L171.8,499.3z" },
  { id: "#path4688", d: "M252.8,511.8l-69.2,5.7l16.3-30.3L252.8,511.8z" },
  { id: "#path4690", d: "M472,354l41.2-70.2l-71.5-1.9L472,354z" },
  { id: "#path4692", d: "M429.6,249.3l12,32.8l34.7-57.8L429.6,249.3z" },
  { id: "#path4694", d: "M513.2,284l86.8,8.9l-65.5-53L513.2,284z" },
  { id: "#path4704", d: "M476.4,224.1l-34.7,57.8l71.5,1.9L476.4,224.1z" },
  { id: "#path4706", d: "M513.2,284l32.7,61.6L600,293L513.2,284z" },
  { id: "#path4708", d: "M449.8,436.1l96.2-90.6l-73.9,8.6L449.8,436.1z" },
  { id: "#path4729", d: "M199.8,487.1l-57.7-18.8l41.2-18.3L199.8,487.1z" },
  { id: "#path4731", d: "M545.9,345.6l27.3,85.9l-123.4,4.7L545.9,345.6z" },
  { id: "#path4733", d: "M600,293l-54.1,52.6l27.3,85.9L600,293z" },
  { id: "#path4735", d: "M449.8,563.4l-136.7-47.1l81.1-29.2L449.8,563.4z" },
  { id: "#path4743", d: "M449.8,563.4l25.5,75.7l9.4-145.4L449.8,563.4z" },
  { id: "#path4747", d: "M251.3,156.7l15.6,68.6l13.4-94.5L251.3,156.7z" },
  { id: "#path4749", d: "M545.9,345.6l-73.9,8.6l41.2-70.2L545.9,345.6z" },
  { id: "#path4755", d: "M297.3,495.7l74-108.4l46.4,9.4L297.3,495.7z" },
  { id: "#path4757", d: "M371.1,152.5l21.6,71l-6.2-71.8L371.1,152.5z" },
  { id: "#path4776", d: "M476.4,224.1l-38.1,1.2l1.7-65L476.4,224.1z" },
  { id: "#path4778", d: "M438.4,225.3L409,208.6l31-48.2L438.4,225.3z" },
  { id: "#path4780", d: "M383.4,106.2l2.9,45.4l12-37.2L383.4,106.2z" },
  { id: "#path4799", d: "M383.4,106.2l-12.3,46.2L267,225.3L383.4,106.2z" },
  { id: "#path4801", d: "M251.3,156.7l29.2-25.9h-51.6L251.3,156.7z" },
  { id: "#path4818", d: "M195.4,218.5l55.9-62l15.6,68.6L195.4,218.5z" },
  { id: "#path4820", d: "M350.9,451.9l-37.8,64.5l81.1-29.2L350.9,451.9z" },
  { id: "#path4822", d: "M321.6,214l71.1,9.5l-93.1,71.5L321.6,214z" },
  { id: "#path4824", d: "M183.4,517.5l43.2,19.8l26-25.5L183.4,517.5z" },
  { id: "#path4858", d: "M429.6,249.3l46.8-25.2l-38.1,1.2L429.6,249.3z" },
  { id: "#path4860", d: "M199.8,487.1l-16.3-36.9l20.6,7.3L199.8,487.1z" },
  { id: "#path4862", d: "M357.7,325.6l-57,19.9l72.8-4.4L357.7,325.6z" },
  { id: "#path4864", d: "M371.4,387.4l-70.7-41.8l72.8-4.4L371.4,387.4z" },
  { id: "#path4866", d: "M199.8,487.1l100.9-141.7l-47.9,166.2L199.8,487.1z" },
  { id: "#path4878", d: "M328.5,318.9l64.2-95.4l-35,102.1L328.5,318.9z" },
  { id: "#path4880", d: "M534.5,239.8l31.7-65.9l-48.2-36.7L534.5,239.8z" },
  { id: "#path4961", d: "M313.1,516.3l-15.9-20.6l-40.7,32.1L313.1,516.3z" },
  { id: "#path5128", d: "M228.8,130.7L109.7,60.9l147,54.7L228.8,130.7z" },
  { id: "#path5130", d: "M252.8,511.8l-26,25.5l30-9.4L252.8,511.8z" },
  { id: "#path5136", d: "M417.9,396.8L351,451.9l98.9-15.6L417.9,396.8z" },
  { id: "#path5138", d: "M183.4,450.2l47.6-102l-89,120.3L183.4,450.2z" },
  { id: "#path5140", d: "M472,354l-30.3-72.1l-84,43.6L472,354z" },
  { id: "#path5142", d: "M484.7,493.6l-9.4,145.4l59.1-130.2L484.7,493.6z" },
  { id: "#path5144", d: "M321.6,214l49.5-61.4L267,225.3L321.6,214z" },
  { id: "#path5166", d: "M267,225.3l-71.5,43.9v-50.7L267,225.3z" },
  { id: "#path5168", d: "M350.9,451.9l98.9-15.6l-55.6,51.1L350.9,451.9z" },
  { id: "#path5170", d: "M440.2,160.4l-53.7-8.7l12-37.2L440.2,160.4z" },
  { id: "#path5172", d: "M386.3,151.7l22.8,56.9l31-48.2L386.3,151.7z" },
  { id: "#path5174", d: "M299.4,295.1L267,225.3l54.5-11.3L299.4,295.1z" },
  { id: "#path5176", d: "M451.9,60.9L440,160.3l36.4-55.5L451.9,60.9z" },
  { id: "#path5186", d: "M150.8,154.2l78.2-23.4l-33.6,87.9L150.8,154.2z" },
  { id: "#path5188", d: "M299.4,295.1L267,225.3l-35.7,62.1L299.4,295.1z" },
  { id: "#path5190", d: "M490.3,173.4l-13.8-68.6l41.7,32.7L490.3,173.4z" },
  { id: "#path5200", d: "M534.5,239.8l-44.3-66.4l28-36.1L534.5,239.8z" },
  { id: "#path5202", d: "M440.2,160.4l36.3,63.8l13.8-50.7L440.2,160.4z" },
  { id: "#path5204", d: "M440.2,160.4l11.8-99.5H419L440.2,160.4z" },
  { id: "#path5206", d: "M534.4,509l-49.7-15.2l88.4-62.1L534.4,509z" },
  { id: "#path5208", d: "M476.4,104.8l-36.3,55.6l50.1,13.1L476.4,104.8z" },
  { id: "#path5258", d: "M409,208.6l-16.5,14.9l45.8,1.8L409,208.6z" },
  { id: "#path5260", d: "M398.2,114.5l-14.8-8.2l35.7-45.4L398.2,114.5z" },
  { id: "#path5262", d: "M484.7,493.6l-90.5-6.4l55.6-51.1L484.7,493.6z" },
  { id: "#path5270", d: "M472,354l-54.1,42.8l32.1,39.3L472,354z" },
  { id: "#path5272", d: "M449.8,563.4l-136.7-47.1l162.1,122.8L449.8,563.4z" },
  { id: "#path5286", d: "M573.2,431.4l-88.4,62.1l-34.9-57.4L573.2,431.4z" },
  { id: "#path5288", d: "M371.4,387.4l100.5-33.2l-98.4-13L371.4,387.4z" },
  { id: "#path5296", d: "M490.3,173.4l23,110.4l-36.8-59.9L490.3,173.4z" },
  { id: "#path5298", d: "M409,208.6l-22.8-56.9l6.2,71.8L409,208.6z" },
  { id: "#path5306", d: "M157.8,498.1l14,1.2l-29.6-30.9L157.8,498.1z" },
  { id: "#path5310", d: "M392.7,223.5l-71.1-9.5l49.5-61.4L392.7,223.5z" },
  { id: "#path5316", d: "M198.3,392.8l32.9-44.6l-46.1-34.5L198.3,392.8z" },
  { id: "#path5324", d: "M429.6,249.3l12,32.8l-84,43.6L429.6,249.3z" },
  { id: "#path5341", d: "M392.7,223.5l45.8,1.8l-8.7,23.9L392.7,223.5z" },
  { id: "#path5343", d: "M371.4,387.4l-74,108.4l3.3-150.2L371.4,387.4z" },
  { id: "#path5345", d: "M185.1,313.9l10.4-44.6l35.7,18.3L185.1,313.9z" },
  { id: "#path5357", d: "M252.8,511.8l47.9-166.2l-3.3,150.2L252.8,511.8z" },
  { id: "#path5359", d: "M231.2,348.2l68.2-53.1l-68.2-7.6V348.2L231.2,348.2z" },
  { id: "#path5361", d: "M513.2,284l21.3-44l-44.3-66.6L513.2,284z" },
  { id: "#path4658", d: "M300.7,345.6l-96.6,112l-20.6-7.3L300.7,345.6z" }
];
